import {
    Alert,
    Box,
    Divider,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
    TextField,
} from "@mui/material";
import { ChangeEvent, useContext, useState } from "react";
import { useSelector } from "react-redux";

import { LoadingButton } from "@mui/lab";
import {
    InvalidDataReportDto,
    InvalidDataReportService,
    InvalidDataReportType,
} from "../../api/psc";
import { DialogContainer, DialogHeader } from "../../components/exports";
import { InvalidDataReportTypeInfoList } from "../../constants/InvalidDataReportContants";
import { DialogContext } from "../../contexts/DialogContext";
import { SnackbarContext } from "../../contexts/SnackbarContext";
import { RootState } from "../../slices/Store";

// updated
export default function AddInvalidDataReportDialog() {
    const projectDetailState = useSelector(
        (state: RootState) => state.projectDetail
    );

    const [requestInProgress, setRequestInProgress] = useState<boolean>(false);
    const [invalidDataReport, setInvalidDataReport] =
        useState<InvalidDataReportDto>({
            projectHashId: projectDetailState.projectHashId,
            type: InvalidDataReportType.WRONG_NUMBER,
            notes: "",
        });

    const { closeDialog } = useContext(DialogContext);
    const { showSnackbar } = useContext(SnackbarContext);

    const handleNotesChange = (
        elem: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        const updatedInvalidDataReport = {
            ...invalidDataReport,
            notes: elem.target.value,
        };
        setInvalidDataReport(updatedInvalidDataReport);
    };

    const handleTypeChange = (
        event: SelectChangeEvent<InvalidDataReportType | undefined>
    ) => {
        if (event === undefined) {
            return;
        }
        const updatedInvalidDataReport = {
            ...invalidDataReport,
            type: event.target.value as InvalidDataReportType,
        };
        setInvalidDataReport(updatedInvalidDataReport);
    };

    const handleSendData = () => {
        setRequestInProgress(true);
        InvalidDataReportService.addInvalidDataReport("1", invalidDataReport)
            .then((r) => {
                closeDialog();
                showSnackbar("گزارش خطا با موفقیت ثبت شد", "success");
            })
            .finally(() => {
                setRequestInProgress(false);
            });
    };

    if (!projectDetailState.projectDetail?.isVisited) {
        return (
            <DialogContainer>
                <DialogHeader title="گزارش خطای پروژه" />
                <Alert severity="error" sx={{ m: 2 }}>
                    برای ثبت گزارش خطا باید اطلاعات سازنده دریافت شده باشد
                </Alert>
            </DialogContainer>
        );
    }

    return (
        <DialogContainer>
            <DialogHeader title="گزارش خطای پروژه" />

            <Box sx={{ p: 2 }}>
                <TextField
                    sx={{ mb: 2 }}
                    multiline
                    rows={4}
                    fullWidth
                    onChange={handleNotesChange}
                    value={invalidDataReport.notes}
                    label="متن خطا"
                    variant="outlined"
                />

                <FormControl fullWidth>
                    <InputLabel>نوع خطا</InputLabel>

                    <Select
                        label="نوع خطا"
                        value={invalidDataReport.type}
                        onChange={handleTypeChange}
                    >
                        {InvalidDataReportTypeInfoList.map((i) => (
                            <MenuItem key={i.id} value={i.id}>
                                {i.title}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <Divider sx={{ my: 2 }} />

                <LoadingButton
                    variant="contained"
                    loading={requestInProgress}
                    onClick={handleSendData}
                >
                    ارسال گزارش خطا
                </LoadingButton>
            </Box>
        </DialogContainer>
    );
}
